'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var contextualTranslation = exports.contextualTranslation = function contextualTranslation(translate, context, baseKey) {
  var _arr = [baseKey, baseKey + '.' + context, baseKey + '.default'];

  for (var _i = 0; _i < _arr.length; _i++) {
    var key = _arr[_i];
    var translation = translate(key);
    if (translation !== '' && translation !== key && typeof translation === 'string') {
      return translation;
    }
  }

  return translate(baseKey);
};

var translateWithDefault = exports.translateWithDefault = function translateWithDefault(translate, key, d) {
  var s = translate(key);
  return s && s !== key ? s : d;
};


//////////////////
// WEBPACK FOOTER
// ./shared/helpers/translate.js
// module id = 149
// module chunks = 0